import { render, staticRenderFns } from "./SelectPostBackgroundModal.vue?vue&type=template&id=05c7d04d"
import script from "./SelectPostBackgroundModal.vue?vue&type=script&lang=js"
export * from "./SelectPostBackgroundModal.vue?vue&type=script&lang=js"
import style0 from "./SelectPostBackgroundModal.vue?vue&type=style&index=0&id=05c7d04d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports